module.exports = __webpack_public_path__ + "static/media/puppy_culture_logo.3ea3bc73.png";